import pic1 from "./image/h-1.avif";
import pic2 from "./image/h-2.avif";
import pic3 from "./image/h-3.avif";
import pic4 from "./image/h-4.avif";

import pic5 from "./image/h-5.avif";
import pic6 from "./image/h-6.avif";
import pic7 from "./image/h-7.avif";
import pic8 from "./image/h-8.avif";
import pic9 from "./image/h-9.avif";
import pic10 from "./image/h-10.avif";
import pic11 from "./image/h-1.avif";
import pic12 from "./image/h-12.avif";
import pic13 from "./image/h-13.avif";
import pic14 from "./image/h-114.avif";
export const image = [
  {
    id: 1,
    img1: pic1,
  },
  {
    id: 2,
    img1: pic2,
  },
  {
    id: 3,
    img1: pic3,
  },
  {
    id: 4,
    img1: pic4,
  },
  {
    id: 5,
    img1: pic5,
  },
  {
    id: 6,
    img1: pic6,
  },
  {
    id: 7,
    img1: pic7,
  },
  {
    id: 8,
    img1: pic8,
  },
  {
    id: 9,
    img1: pic9,
  },
  {
    id: 10,
    img1: pic10,
  },
  {
    id: 11,
    img1: pic11,
  },
  {
    id: 12,
    img1: pic12,
  },
  {
    id: 13,
    img1: pic13,
  },
  {
    id: 14,
    img1: pic14,
  },
];
